import {ContentInfusionData, CTA} from '../../types/travel.ts'

interface ContentInfusionStyle1Props {
    data: ContentInfusionData
}

export function ContentInfusionStyleBasic({data}: ContentInfusionStyle1Props) {
    if (!data) return null;

    const {image, cta } = data;

    const isValidCTA = (cta: CTA | string): cta is CTA => {
        return typeof cta === 'object' && cta !== null && 'title' in cta && 'url' in cta;
    };

    const bg = image ? `background-image: url(${image})` : "";


    const handleTriggerClick = (cta : string | CTA) => {
        if (!isValidCTA(cta)) return;

        const target = cta.target || '_self';

        if (target === '_blank') {
            window.open(cta.url, '_blank');
        } else {
            window.location.href = cta.url;
        }
    };

    return (
        <div onClick={() => handleTriggerClick(cta)} className={`basic text-white bg-gray-500 content-infusion style-1 hidden lg:block bg-cover bg-center bg-no-repeat ${isValidCTA(cta) ? 'cursor-pointer' : ''}`} style={bg}>
            <div className="pt-10 pb-9 px-5 relative content-infusion-inner flex h-full items-center flex-col justify-between">
                <span></span>
                {/* CTA */}
                {isValidCTA(cta) && cta.title && cta.url && (
                    <div className="mt-9 w-full text-center ">
                        <a
                            href={cta.url}
                            target={cta.target || '_self'}
                            className="btn white height-50  duration-200!"
                        >
                            {cta.title}
                        </a>
                    </div>
                )}

            </div>
        </div>
    )
}
